import React from "react";
import Button from "./Button";

const FootInfo = () => {
  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-7">
        <a
          href="https://docs.google.com/document/d/11ItCVQR-7QbYMkyT3JYhLa6guN0pZiDMdxSN7tZ3DLA/edit?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            title="UPDATES"
            className="py-[5px] px-2 !max-w-[131px] !min-w-[131px]"
          />
        </a>
        <a
          href="https://sapient-dev-bucket-projects.s3.ap-south-1.amazonaws.com/noora-health/uploads/98886631932083711832.References---Web-of-Care-Website-%281%29-%281%29.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue underline"
        >
          <Button
            title="REFERENCES"
            className="py-[5px] px-2 !max-w-[131px] !min-w-[131px]"
          />
        </a>
      </div>

      <p className="text-black text-xs font-medium leading-relaxed border-t-[0.5px] border-black pt-3">
        The data on this website may have updates or additional relevant data.
        View new or updated data by selecting the UPDATES button.
      </p>
    </div>
  );
};

export default FootInfo;
